import { AutoAwesome, Psychology, Explore, Construction, RocketLaunch, EmojiEvents } from "@mui/icons-material";

export const FlagTypes = ['work', 'health', 'education', 'relation', 'self-knowing', 'action', 'experience', 'self-awareness', 'discovery', 'preparation', 'professional'];
const FlagMapper = (type, iconProps) => {
  let icon = null;
  let circleColor = "black";
  let titleColor = "black";
  let title = "نامعلوم";
  switch (type) {
    case "work":
      title = "شغل";
      icon = (
        <svg
          {...iconProps}
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_34_54)">
            <path
              d="M20.451 6.3768H16.3883V4.34544C16.3883 3.21804 15.4844 2.31409 14.3569 2.31409H10.2942C9.16684 2.31409 8.26289 3.21804 8.26289 4.34544V6.3768H4.20018C3.07278 6.3768 2.17898 7.28075 2.17898 8.40815L2.16882 19.5806C2.16882 20.708 3.07278 21.612 4.20018 21.612H20.451C21.5784 21.612 22.4824 20.708 22.4824 19.5806V8.40815C22.4824 7.28075 21.5784 6.3768 20.451 6.3768ZM14.3569 6.3768H10.2942V4.34544H14.3569V6.3768Z"
              fill="#EB3223"
            />
          </g>
          <defs>
            <clipPath id="clip0_34_54">
              <rect
                width="24.3763"
                height="24.3763"
                fill="white"
                transform="translate(0.136963 0.282227)"
              />
            </clipPath>
          </defs>
        </svg>
      );
      circleColor = "#FFF0F0";
      titleColor = "#EB3223";
      break;
    case "health":
      title = "سلامتی";
      circleColor = "rgb(248,255,246)";
      titleColor = "rgb(35, 212, 0)";
      icon = (
        <svg
          {...iconProps}
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_93_14)">
            <path
              d="M24 42.7L21.1 40.06C10.8 30.72 4 24.56 4 17C4 10.84 8.84 6 15 6C18.48 6 21.82 7.62 24 10.18C26.18 7.62 29.52 6 33 6C39.16 6 44 10.84 44 17C44 24.56 37.2 30.72 26.9 40.08L24 42.7Z"
              fill="#75F94C"
            />
          </g>
          <defs>
            <clipPath id="clip0_93_14">
              <rect width="48" height="48" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "education":
      title = "تحصیل";
      circleColor = "rgb(255,253,248)";
      titleColor = "rgb(230, 175, 0)";
      icon = (
        <svg
          {...iconProps}
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_92_11)">
            <path
              d="M10 26.36V34.36L24 42L38 34.36V26.36L24 34L10 26.36ZM24 6L2 18L24 30L42 20.18V34H46V18L24 6Z"
              fill="#F9D978"
            />
          </g>
          <defs>
            <clipPath id="clip0_92_11">
              <rect width="48" height="48" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "relation":
      title = "روابط";
      circleColor = "rgb(249,242,255)";
      titleColor = "#8F00FF";
      icon = (
        <svg
          {...iconProps}
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_92_4)">
            <path
              d="M24 25.5C27.26 25.5 30.14 26.28 32.48 27.3C34.64 28.26 36 30.42 36 32.76V36H12V32.78C12 30.42 13.36 28.26 15.52 27.32C17.86 26.28 20.74 25.5 24 25.5ZM8 26C10.2 26 12 24.2 12 22C12 19.8 10.2 18 8 18C5.8 18 4 19.8 4 22C4 24.2 5.8 26 8 26ZM10.26 28.2C9.52 28.08 8.78 28 8 28C6.02 28 4.14 28.42 2.44 29.16C0.96 29.8 0 31.24 0 32.86V36H9V32.78C9 31.12 9.46 29.56 10.26 28.2ZM40 26C42.2 26 44 24.2 44 22C44 19.8 42.2 18 40 18C37.8 18 36 19.8 36 22C36 24.2 37.8 26 40 26ZM48 32.86C48 31.24 47.04 29.8 45.56 29.16C43.86 28.42 41.98 28 40 28C39.22 28 38.48 28.08 37.74 28.2C38.54 29.56 39 31.12 39 32.78V36H48V32.86ZM24 12C27.32 12 30 14.68 30 18C30 21.32 27.32 24 24 24C20.68 24 18 21.32 18 18C18 14.68 20.68 12 24 12Z"
              fill="#8F00FF"
            />
          </g>
          <defs>
            <clipPath id="clip0_92_4">
              <rect width="48" height="48" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;

    case "self-knowing":
      title = "خودشناسی";
      circleColor = "rgb(247,249,254)";
      titleColor = "rgb(86, 134, 225)";
      icon = (
        <svg
          {...iconProps}
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_93_17)">
            <path
              d="M26 17.14C24.42 17.14 23.14 18.42 23.14 20C23.14 21.58 24.42 22.86 26 22.86C27.58 22.86 28.86 21.58 28.86 20C28.86 18.42 27.58 17.14 26 17.14Z"
              fill="#5686E1"
            />
            <path
              d="M26 6C18.5 6 12.4 11.88 12.04 19.28L8.2 24.4C7.7 25.06 8.18 26 9 26H12V32C12 34.2 13.8 36 16 36H18V42H32V32.64C36.72 30.4 40 25.58 40 20C40 12.26 33.74 6 26 6ZM32 20C32 20.26 31.98 20.52 31.96 20.78L33.62 22.1C33.78 22.22 33.82 22.42 33.72 22.6L32.12 25.38C32.02 25.56 31.8 25.62 31.64 25.56L29.66 24.76C29.24 25.08 28.8 25.34 28.32 25.54L28 27.66C27.98 27.86 27.8 28 27.6 28H24.4C24.2 28 24.04 27.86 24 27.66L23.7 25.54C23.2 25.34 22.76 25.08 22.34 24.76L20.36 25.56C20.18 25.62 19.96 25.56 19.86 25.38L18.26 22.6C18.16 22.44 18.2 22.22 18.36 22.1L20.04 20.78C20.02 20.52 20 20.26 20 20C20 19.74 20.04 19.46 20.08 19.22L18.38 17.9C18.22 17.78 18.18 17.58 18.28 17.38L19.88 14.62C19.98 14.44 20.18 14.38 20.36 14.44L22.36 15.24C22.76 14.94 23.22 14.66 23.7 14.46L24 12.34C24.04 12.14 24.2 12 24.4 12H27.6C27.8 12 27.96 12.14 28 12.34L28.3 14.46C28.78 14.66 29.22 14.92 29.64 15.24L31.64 14.44C31.82 14.38 32.04 14.44 32.12 14.62L33.72 17.38C33.82 17.56 33.78 17.78 33.62 17.9L31.92 19.22C31.98 19.46 32 19.72 32 20Z"
              fill="#5686E1"
            />
          </g>
          <defs>
            <clipPath id="clip0_93_17">
              <rect width="48" height="48" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "start_point":
      title = "نقطه شروع";
      circleColor = "rgba(200,200,200,1)";
      icon = <svg {...iconProps} focusable="false" ariaHidden="true" viewBox="0 0 24 24" ><path d="M14.4 6 14 4H5v17h2v-7h5.6l.4 2h7V6z"></path></svg>
      break;
    case "action":
      title = "اقدامک";
      circleColor = "rgb(235, 235, 255)";
      titleColor = "#3C486B";
      icon = (
        <AutoAwesome {...iconProps} style={{fill : '#3C486B'}} color="#3C486B" />
      );
      break;
    case "self-awareness":
      title = "تحصیل و دانشگاه";
      circleColor = "rgb(224, 242, 241)";
      titleColor = "#00897B";
      icon = (
        <Psychology {...iconProps} style={{fill: '#00897B'}} />
      );
      break;
    case "discovery":
      title = "مهارت‌های پایه";
      circleColor = "rgb(252, 228, 236)";
      titleColor = "#D81B60";
      icon = (
        <Explore {...iconProps} style={{fill: '#D81B60'}} />
      );
      break;
    case "preparation":
      title = "تجربه شغلی";
      circleColor = "rgb(232, 234, 246)";
      titleColor = "#3949AB";
      icon = (
        <Construction {...iconProps} style={{fill: '#3949AB'}} />
      );
      break;
    case "experience":
      title = "ارتقای دانش و مهارت";
      circleColor = "rgb(251, 233, 231)";
      titleColor = "#E64A19";
      icon = (
        <RocketLaunch {...iconProps} style={{fill: '#E64A19'}} />
      );
      break;
    case "professional":
      title = "حرفه‌ای سازی و رشد";
      circleColor = "rgb(239, 235, 233)";
      titleColor = "#6D4C41";
      icon = (
        <EmojiEvents {...iconProps} style={{fill: '#6D4C41'}} />
      );
      break;
    default:
  }
  return {
    icon, circleColor, titleColor, title
  }
}
export default FlagMapper;